import React from 'react';
import {Switch} from 'react-router-dom';
import {PrivateRoute} from '../../../shared/components/PrivateRoute';
import DashboardPage from '../../pages/DashboardPage';
import PerformancePage from '../../pages/PerformancePage';
import WealthAlertsPage from '../../pages/WealthAlertsPage';
import TransactionsPage from '../../pages/TransactionsPage';
import HoldingsPage from '../../pages/HoldingsPage';
import ExposurePage from '../../pages/ExposurePage';
import PortfolioInfoPage from '../../pages/PortfolioInfoPage';
import BalancePage from '../../pages/BalancePage';
import AccountsPage from '../../pages/AccountsPage';
import RiskManagementPage from '../../pages/RiskManagementPage';
import Insights from '../../pages/Insights';
import ProbabilityOfSuccessPage from '../../pages/ProbabilityOfSuccessPage';

const sections = () => (
  [
    {
      label: 'Portfolio',
      page: '/portfolio',
      subsections: [{label: 'Portfolio', page: '/portfolio'}],
      content: <Switch>
        <PrivateRoute exact path='/portfolio/insights' component={Insights}/>
        <PrivateRoute path='/portfolio/accounts' component={AccountsPage}/>
        <PrivateRoute path='/portfolio/wealthalerts' component={WealthAlertsPage}/>
        <PrivateRoute exact path='/portfolio/performance' component={PerformancePage}/>
        <PrivateRoute path='/portfolio/balance' exact component={BalancePage}/>
        <PrivateRoute exact path='/portfolio/info' component={PortfolioInfoPage}/>
        <PrivateRoute exact path='/portfolio/pos' component={ProbabilityOfSuccessPage}/>
        <PrivateRoute exact path='/portfolio/exposure' component={ExposurePage}/>
        <PrivateRoute exact path='/portfolio/transactions' component={TransactionsPage}/>
        <PrivateRoute exact path='/portfolio/holdings' component={HoldingsPage}/>
        <PrivateRoute exact path='/portfolio/accounts' component={AccountsPage}/>
        <PrivateRoute exact path='/portfolio/risk' component={RiskManagementPage}/>
        <PrivateRoute path='/portfolio' component={DashboardPage}/>
      </Switch>,
    },
  ]
);

export default {sections};
